import axios from "axios"
import { API_URLS } from "../constants/ApiUrls"

export const fetchEmergingAlertHightlightsApi = async () => {
    const response = await axios.get(`${API_URLS.EMERGING_ALERTS}/highlights`);
    if (response.status === 200)
        return response.data;
    return null;
}

export const fetchSiteRatingsApi = async () => {
    const response = await axios.get(`${API_URLS.EMERGING_ALERTS}/site-ratings`);
    if (response.status === 200)
        return response.data;
    return null;
}

export const fetchAreaViewTilesApi = async () => {
    const response = await axios.get(`${API_URLS.EMERGING_ALERTS}/area-view-tiles`);
    if (response.status === 200)
        return response.data;
    return null;
}

export const fetchFuncLocationInfo = async () => {
    const response = await axios.get(`${API_URLS.EMERGING_ALERTS}/func-loc`);
    if (response.status === 200) {
        return response.data;
    }
    return null;
}